var render = function render(){var _vm=this,_c=_vm._self._c;return _c('billing-report-panel',{attrs:{"report-key":"transfer-insurance","route":"/reports/billing-transfer-insurance","file-name":"repasse-por-convenio.xlsx","period-label":"Período do faturamento","columns":_vm.columns,"show-professional":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }